<div class="main-content">
	<div class="container-fluid">

		<!-- Toast notifications -->
		<div class="toast-container" aria-live="polite">
			<div *ngFor="let t of toastQueue"
				class="toast-item"
				[ngClass]="'toast-' + t.type">
				{{ t.msg }}
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}">
						<h4 class="card-title">
							<i class="material-icons" (click)="back()" style="cursor:pointer">arrow_left</i>
							Channel Orders
						</h4>
						<p class="card-category">LeafLink &amp; Distru orders — push &amp; status</p>
					</div>
					<div class="card-body">

						<!-- Filters -->
						<div class="row mb-3 align-items-end">
							<div class="col-md-2">
								<mat-form-field appearance="fill" class="w-100">
									<mat-label>From</mat-label>
									<input matInput type="date" [(ngModel)]="filters.datefrom">
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="fill" class="w-100">
									<mat-label>To</mat-label>
									<input matInput type="date" [(ngModel)]="filters.dateto">
								</mat-form-field>
							</div>
							<div class="col-md-2">
								<mat-form-field appearance="fill" class="w-100">
									<mat-label>Channel</mat-label>
									<mat-select [(ngModel)]="filters.channel">
										<mat-option value="">All</mat-option>
										<mat-option value="leaflink">LeafLink</mat-option>
										<mat-option value="distru">Distru</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-3">
								<mat-form-field appearance="fill" class="w-100">
									<mat-label>Search</mat-label>
									<input matInput [(ngModel)]="filters.search" placeholder="Order #, customer…">
									<mat-icon matSuffix>search</mat-icon>
								</mat-form-field>
							</div>
							<div class="col-md-3 d-flex gap-2">
								<button mat-raised-button color="primary" (click)="load()" [disabled]="loading">
									<mat-icon>refresh</mat-icon> Search
								</button>
								<button mat-stroked-button (click)="exportCsv()" [disabled]="!orders.length">
									<mat-icon>file_download</mat-icon> CSV
								</button>
								<button mat-stroked-button (click)="pollInbound('leaflink')" matTooltip="Poll new LeafLink orders">
									<mat-icon>sync</mat-icon> LL
								</button>
								<button mat-stroked-button (click)="pollInbound('distru')" matTooltip="Poll new Distru orders">
									<mat-icon>sync</mat-icon> DS
								</button>
							</div>
						</div>

						<!-- Table -->
						<div *ngIf="loading" class="text-center py-4"><mat-spinner diameter="40"></mat-spinner></div>

						<mat-table [dataSource]="orders" *ngIf="!loading" class="w-100">

							<ng-container matColumnDef="orderno">
								<mat-header-cell *matHeaderCellDef>Order #</mat-header-cell>
								<mat-cell *matCellDef="let r"><strong>{{ r.orderno }}</strong></mat-cell>
							</ng-container>

							<ng-container matColumnDef="customer_name">
								<mat-header-cell *matHeaderCellDef>Customer</mat-header-cell>
								<mat-cell *matCellDef="let r">{{ r.customer_name }}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="orddate">
								<mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
								<mat-cell *matCellDef="let r">{{ r.orddate | date:'MM/dd/yy' }}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="order_channel">
								<mat-header-cell *matHeaderCellDef>Channel</mat-header-cell>
								<mat-cell *matCellDef="let r">
									<span class="badge" [ngClass]="r.order_channel === 'leaflink' ? 'badge-leaflink' : 'badge-distru'">
										{{ r.order_channel === 'leaflink' ? 'LeafLink' : 'Distru' }}
									</span>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="order_total">
								<mat-header-cell *matHeaderCellDef>Total</mat-header-cell>
								<mat-cell *matCellDef="let r">{{ r.order_total | currency }}</mat-cell>
							</ng-container>

							<ng-container matColumnDef="ll_push_status">
								<mat-header-cell *matHeaderCellDef>LL Push</mat-header-cell>
								<mat-cell *matCellDef="let r">
									<span [class]="pushBadgeClass(r.ll_push_status)"
										[matTooltip]="r.ll_push_error || r.ll_external_id || ''">
										{{ r.ll_push_status || '—' }}
									</span>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="distru_push_status">
								<mat-header-cell *matHeaderCellDef>Distru Push</mat-header-cell>
								<mat-cell *matCellDef="let r">
									<span [class]="pushBadgeClass(r.distru_push_status)"
										[matTooltip]="r.distru_push_error || r.distru_external_id || ''">
										{{ r.distru_push_status || '—' }}
									</span>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="actions">
								<mat-header-cell *matHeaderCellDef></mat-header-cell>
								<mat-cell *matCellDef="let r">
									<button *ngIf="r.order_channel === 'leaflink' || !r.order_channel"
										mat-stroked-button
										class="btn-xs me-1"
										(click)="r.ll_push_status === 'failed' || r.ll_push_status === 'dead_letter' ? retry(r.orderno,'leaflink') : push(r.orderno,'leaflink')"
										[disabled]="isPushing(r.orderno,'leaflink')"
										[color]="r.ll_push_status === 'failed' ? 'warn' : 'primary'">
										<mat-spinner *ngIf="isPushing(r.orderno,'leaflink')" diameter="14"></mat-spinner>
										<span *ngIf="!isPushing(r.orderno,'leaflink')">{{ pushLabel(r,'leaflink') }}</span>
									</button>
									<button *ngIf="r.order_channel === 'distru' || !r.order_channel"
										mat-stroked-button
										class="btn-xs"
										(click)="r.distru_push_status === 'failed' || r.distru_push_status === 'dead_letter' ? retry(r.orderno,'distru') : push(r.orderno,'distru')"
										[disabled]="isPushing(r.orderno,'distru')"
										[color]="r.distru_push_status === 'failed' ? 'warn' : 'primary'">
										<mat-spinner *ngIf="isPushing(r.orderno,'distru')" diameter="14"></mat-spinner>
										<span *ngIf="!isPushing(r.orderno,'distru')">{{ pushLabel(r,'distru') }}</span>
									</button>
								</mat-cell>
							</ng-container>

							<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
							<mat-row *matRowDef="let r; columns: displayedColumns;"></mat-row>
						</mat-table>

						<div *ngIf="!loading && orders.length === 0" class="text-center text-muted py-4">
							No channel orders found for the selected filters.
						</div>

						<div *ngIf="total > 0" class="text-muted small mt-2">
							Showing {{ orders.length }} of {{ total }} orders
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
